// year값에 따른 월별 총 일수 반환 (윤달 계산)
export const getAllDateArr = (year: number) => {
  const isYoundal = (year % 4 == 0 && year % 100 !== 0) || year % 400 == 0;

  return [31, isYoundal ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
};

// 월/일 - 0을 포함한 2자리 문자열로 맞추기
export const setZeroPad = (str: string | number) => {
  return `${str}`?.padStart(2, '0');
};

// 해당 월 1일 yy-mm-dd로 변환
export const getYMDFirstDate = (year: number, month: number) => {
  return `${year}-${setZeroPad(month)}-${setZeroPad(1)}`;
};

// 해당 월 마지막일 yy-mm-dd로 변환
export const getYMDLastDate = (year: number, month: number) => {
  const lastDate = month >= 1 ? getAllDateArr(year)[month - 1] : 0;
  return `${year}-${setZeroPad(month)}-${setZeroPad(lastDate)}`;
};
